module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "navbar-item"
  }, [_c('button', {
    attrs: {
      "title": "Link"
    },
    on: {
      "click": _vm.insert
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-084359dd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navBarItems/link.vue
// module id = 315
// module chunks = 0